import { useEffect } from 'react';
import { Box } from '@gemini/core';
import { Dropdown } from '@gemini/ui';
import { IFieldProps, TSelectOptions } from '@mfe-types/field';
import { CSSObject, Global } from '@emotion/react';

type Options = {
    values: TSelectOptions;
};

const selectWrapperStyles = (): CSSObject => ({
    '.dropdown-container': {
        button: {
            justifyContent: 'space-between',
            'div:first-child': {
                display: 'none',
            },
        },
    },
});

const SelectWrapper = ({
    field,
    options,
    texts,
    styles,
}: Required<IFieldProps<any, any, Options>>) => {
    useEffect(() => document.getElementById(field.name)?.removeAttribute('aria-readonly'), []);

    const items = options?.values?.map(({ value, label }) => ({
        id: value ?? '',
        label: label ?? '',
    }));

    // since it's not possible to have a displayed value different from the dropdown value, we display the suffix instead when needed.
    const hasSuffix = options?.values[0]?.shortLabel;
    const shortLabel = options?.values?.find((c) => c.value === field.value)?.shortLabel;

    return (
        <Box {...styles} testId={field.name} unsafe_className="dropdown-container">
            {shortLabel && <Global styles={selectWrapperStyles()} />}
            <Dropdown
                {...field}
                {...(hasSuffix && { suffix: shortLabel })}
                label={texts?.label ?? ''}
                items={items}
                onChange={field.onChange}
                isDisabled={field.isDisabled || !options?.values?.length}
                placeholder={texts.placeholder}
                isFullWidth
            />
        </Box>
    );
};

export default SelectWrapper;
